<div class="navigation">
	@for (route of breadcrumb; track $index) {
		<a [routerLink]="route.route" [queryParams]="route.queryParams" [fragment]="route.fragment">< {{ route.label }}</a>
	}
</div>
